import { Interval } from "luxon";

// is the interval the full day; this is not checking PlannerEventCard.isAllDay
export const hasIntervalAllDayLong = ({ interval }: { interval: Interval }) =>
  interval.start.hour === 0 &&
  interval.start.minute === 0 &&
  interval.end.hour === 23 &&
  interval.end.minute === 59;
